// extracted by mini-css-extract-plugin
export default {"adminHeader":"AdminLayout_adminHeader__LHDP6","logo":"AdminLayout_logo__XeMA+","adminNavLink":"AdminLayout_adminNavLink__EhcBH","activeTab":"AdminLayout_activeTab__kelxQ"};